// Paid chat conversation id. Created lazily, only when a paid module is opened,
// so free tier and calculator visitors never get one.
const KEY = 'coach_rands_session';

export function getPaidSessionId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    id = 'session_' + Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    localStorage.setItem(KEY, id);
  }
  return id;
}
